import { defineComponent, computed } from 'vue';
import _ from 'lodash';
export default defineComponent({
  name: 'UcButtonGroup',
  props: {
    buttons: {
      type: Array,
      default: () => []
    }
  },
  setup: props => {
    const buttonEmitName = buttonText => {
      return _.kebabCase(buttonText);
    };
    const leftButtons = computed(() => {
      return props.buttons.filter(button => button.location === 'left');
    });
    const rightButtons = computed(() => {
      return props.buttons.filter(button => button.location === 'right');
    });
    return {
      buttonEmitName,
      leftButtons,
      rightButtons
    };
  }
});